/**
 * @enum {enumImageFileSize} An enumeration of different image file sizes that are used in the app
 */
export enum enumImageFileSize {
  Thumbnail = 'Thumbnail', // max of 100x100px
  Small = 'Small', // max of 300x300px
  Medium = 'Medium', // max of 500x500px
  Large = 'Large', // max of 1000x1000px
}